import React, { PureComponent, useState } from 'react';
import OfferIntro from '../../components/OfferIntro';
import StreamField from '../../components/StreamField';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { basePageWrap } from '../BasePage';
import styles from './RichTextPage.module.scss';
import ButtonSecondary from '../../components/ButtonSecondary';
import ButtonSecondaryEllipse from '../../components/ButtonSecondaryEllipse';
import RelatedContent from '../../components/RelatedContent';
import Modal from '../../components/Modal/Modal';
import Head from 'next/head';

const richTextPageDefaultPropImage = {};
const richTextPageDefaultPropBlocks = [];

const RichTextPage = ({
    offerIntro,
    blocks = richTextPageDefaultPropBlocks,
    lastUpdated = '',
    relatedContent = {},
    isDesktop,
    seo,
    title,
    lastPublishedAt,
    publicUpdatedAt,
}) => {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const rootClasses = classNames(styles['Root'], {});
    const wrapperClasses = classNames(styles['Wrapper'], {});
    const footerClasses = classNames(styles['Footer'], 'grid', {});

    const share = {
        title: offerIntro?.titleTop + ' ' + offerIntro?.titleBottom,
        onClose: () => setShowModal(false),
        onClick: () => setShowModal(true),
        isVisible: showModal,
        url: '',
    };

    const articleSchema = {
        '@context': 'https://schema.org',
        '@type': 'Article',
        name: title || '',
        headline: title || '',
        description: offerIntro?.text || '',
        image: seo?.seoOgImage || '',
        url: seo?.seoOgUrl || '',
        publisher: {
            '@type': 'Organization',
            name: 'Stockholm Business Region',
            url: 'https://www.stockholmbusinessregion.com',
            logo: {
                '@type': 'ImageObject',
                url: 'https://www.stockholmbusinessregion.com/static/logo.png',
            },
        },
    };

    return (
        <>
            <Head>
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(articleSchema),
                    }}
                />
            </Head>
            <div className={rootClasses}>
                <OfferIntro isDesktop={isDesktop} {...offerIntro} share={share} icon="icon-share" richtext={true} />
                <div className={wrapperClasses}>
                    <section className={styles['Container']}>{blocks && <StreamField blocks={blocks} />}</section>
                    <section className={footerClasses}>
                        <div className={styles['FooterWrapper']}>
                            <div className={styles['Line']} />
                            <div className={styles['Buttons']}>
                                <ButtonSecondary
                                    modifiers={['InlineFlex', 'IconRotate45', 'Share']}
                                    borderColor="black"
                                    onClick={() => setShowModal(true)}
                                    icon="icon-share-black">
                                    {t('Generic.share')}
                                </ButtonSecondary>

                                {/*
              {t('RichText.helpful')}
              <div className={styles['ButtonThumb']}>
                <ButtonSecondaryEllipse
                  icon="icon-thumbs-up"
                  size="large"
                  modifiers={['Black', 'NoPadding']}></ButtonSecondaryEllipse>
                <ButtonSecondaryEllipse
                  icon="icon-thumbs-down"
                  size="large"
                  modifiers={['Black', 'NoPadding']}></ButtonSecondaryEllipse>
              </div>
                */}
                                <div className={styles['LastUpdated']}>
                                    {t('RichText.lastUpdated')}: {lastUpdated}
                                </div>
                            </div>
                        </div>
                    </section>
                    {!!relatedContent?.titleTop && (
                        <RelatedContent {...relatedContent} isDesktop={isDesktop} modifiers={['RichTextPage']} />
                    )}
                </div>
            </div>

            {showModal && <Modal {...share} />}
        </>
    );
};

export default basePageWrap(RichTextPage);

RichTextPage.propTypes = {
    titleTop: PropTypes.string,
    titleBottom: PropTypes.string,
    text: PropTypes.string,
    image: PropTypes.object,
    blocks: PropTypes.array,
    lastUpdated: PropTypes.string,
};
